module.exports = __webpack_public_path__ + "static/media/next.c29ae119.svg";